(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/archive-rules', {
      templateUrl: 'modules/app/data/archiving/archiving.html',
      controller: 'StatementArchivingCtrl',
      resolve: {
        include: function include() {
          return 'index';
        }
      }
    });
  }]).factory('StatementArchivingUtils', function () {
    return {
      buildFilter: function buildFilter(activities, verbs, dateFilter) {
        var filter = {};
        if (activities.length > 0) {
          var idsObj = {
            activityIds: {
              ids: activities.map(function (a) {
                return a.activityId;
              }),
              regExp: true
            }
          };
          _.extend(filter, idsObj);
        }
        if (verbs.length > 0) {
          var _idsObj = {
            verbIds: {
              ids: verbs.map(function (v) {
                return v.verbId;
              }),
              regExp: true
            }
          };
          _.extend(filter, _idsObj);
        }
        if (dateFilter) {
          _.extend(filter, {
            dateFilter: dateFilter
          });
        }
        return filter;
      }
    };
  }).controller('StatementArchivingCtrl', ['$controller', '$scope', '$q', '$location', '$http', '$uibModal', '$anchorScroll', 'Logger', 'UserRoles', 'User', 'Api', 'TinCanJS', 'Alerts', 'StatementArchivingUtils', 'StatementUtils', 'OrganizationSettings', function ($controller, $scope, $q, $location, $http, $uibModal, $anchorScroll, Logger, UserRoles, User, Api, TinCanJS, Alerts, StatementArchivingUtils, StatementUtils, OrganizationSettings) {
    var user = User.get();
    var canAccessStatementArchiving = OrganizationSettings.hasFeature("statementArchivingAccess") && UserRoles.isOrgAdmin(user) || UserRoles.isSystemAdmin(user);
    if (!canAccessStatementArchiving) {
      $location.path('/');
    }
    var defaultDateFilter = {
      dateType: 'older_than',
      olderThanAmount: 1,
      olderThanType: 'days',
      customDateFrom: null,
      customDateTo: null,
      fieldName: 'timestamp'
    };

    // Controller state
    $scope.section = 'archive-rules';
    $scope.loading = false;
    $scope.loadingStatements = false;
    $scope.statementsCount = 0;
    $scope.showRuleForm = false;
    $scope.selectedIdType = {
      activity: 'Exact',
      verb: 'Exact'
    };
    $scope.cfg = {
      ruleDescription: '',
      selectedActivities: [],
      selectedVerbs: []
    };
    $scope.partialIds = {
      activityId: '',
      verbId: ''
    };
    $scope.datePickerConfig = {
      lightTheme: true,
      showOlderThan: true
    };
    $scope.formErrors = [];
    $scope.descriptionHelp = 'Add a short, useful description for your rule.';
    $scope.activityHelp = 'Choose the activity ids that should be captured by this rule. You may select the exact id, or specify how all the activity ids start (e.g. http://example.com).';
    $scope.verbHelp = 'Choose the verb ids that should be captured by this rule. You may select the exact id, or specify how all the verb ids start (e.g. http://example.com).';
    $scope.dateFilterHelp = 'You can add a date filter to select statements within a custom date range, or statements older than a certain time frame (e.g. four weeks). You may choose whether to apply the filter to the timestamp or stored date.';
    $scope.defaultSortBy = '-created';
    $scope.sortControls = [{
      'title': 'Description'
    }, {
      'title': 'Filter'
    }, {
      'title': 'Total Archived',
      'options': {
        'Ascending': 'totalStatementsArchived',
        'Descending': '-totalStatementsArchived'
      }
    }, {
      'title': 'Created',
      'options': {
        'Ascending': 'created',
        'Descending': '-created'
      }
    }, {
      'title': 'User'
    }, {
      'title': 'State'
    }, {
      'title': ''
    }];
    $scope.apiUrl = Api.url('/statement-archive-rules', false, false);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });

    // Activities Section
    $scope.selectActivityIdType = function (type) {
      $scope.selectedIdType.activity = type;
    };
    $scope.addActivity = function (activity) {
      activity.showIcons = false;
      if (!isSelectedActivity(activity)) {
        $scope.cfg.selectedActivities.push(activity);
      }
    };
    $scope.addPartialActivity = function () {
      if ($scope.partialIds.activityId.includes('.*')) {
        Alerts.raiseAlert({
          "type": "warning",
          "text": "Regular expressions are not allowed as part of user input. They will be added automatically if necessary.",
          "autoDismiss": true,
          "autoDismissTimeout": 3000
        });
        return;
      }
      var activity = {
        activityId: $scope.partialIds.activityId + '.*',
        showIcons: false
      };
      if (!isSelectedActivity(activity)) {
        $scope.cfg.selectedActivities.push(activity);
      }
      $scope.partialIds.activityId = '';
    };
    $scope.removeActivity = function (activity) {
      $scope.cfg.selectedActivities = $scope.cfg.selectedActivities.filter(function (a) {
        return a.activityId !== activity.activityId;
      });
    };
    var isSelectedActivity = function isSelectedActivity(activity) {
      var actIds;
      if (activity.activityId) {
        actIds = _.pluck($scope.cfg.selectedActivities, 'activityId');
        return _.contains(actIds, activity.activityId);
      } else {
        actIds = _.pluck($scope.cfg.selectedActivities, 'id');
        return _.contains(actIds, activity.id);
      }
    };

    // Verb Section
    $scope.selectVerbIdType = function (type) {
      $scope.selectedIdType.verb = type;
    };
    $scope.addVerb = function (verb) {
      verb.showIcons = false;
      if (!isSelectedVerb(verb)) {
        $scope.cfg.selectedVerbs.push(verb);
      }
    };
    $scope.addPartialVerb = function () {
      if ($scope.partialIds.verbId.includes('.*')) {
        Alerts.raiseAlert({
          "type": "warning",
          "text": "Please remove any included regular expressions. Regular expressions will be added for Starts With ids automatically.",
          "autoDismiss": true,
          "autoDismissTimeout": 3000
        });
        return;
      }
      var verb = {
        verbId: $scope.partialIds.verbId + '.*',
        showIcons: false
      };
      if (!isSelectedVerb(verb)) {
        $scope.cfg.selectedVerbs.push(verb);
      }
      $scope.partialIds.verbId = '';
    };
    $scope.removeVerb = function (verb) {
      $scope.cfg.selectedVerbs = $scope.cfg.selectedVerbs.filter(function (a) {
        return a.verbId !== verb.verbId;
      });
    };
    var isSelectedVerb = function isSelectedVerb(verb) {
      var verbIds;
      if (verb.verbId) {
        verbIds = _.pluck($scope.cfg.selectedVerbs, 'verbId');
        return _.contains(verbIds, verb.verbId);
      } else {
        verbIds = _.pluck($scope.cfg.selectedVerbs, 'id');
        return _.contains(verbIds, verb.id);
      }
    };

    // Date Section
    $scope.addDateFilter = function () {
      $scope.datePickerConfig.dateFilter = defaultDateFilter;
    };

    // Form
    $scope.openRuleForm = function () {
      $scope.showRuleForm = true;
    };
    $scope.createRule = function () {
      $scope.formErrors = [];
      var _$scope$cfg = $scope.cfg,
        selectedActivities = _$scope$cfg.selectedActivities,
        selectedVerbs = _$scope$cfg.selectedVerbs,
        ruleDescription = _$scope$cfg.ruleDescription;
      var dateFilter = $scope.datePickerConfig.dateFilter;
      if (!validateRule(ruleDescription, selectedActivities, selectedVerbs, dateFilter)) {
        $anchorScroll('ruleForm');
        return;
      }
      $scope.filter = StatementArchivingUtils.buildFilter(selectedActivities, selectedVerbs, dateFilter);
      var payload = {
        description: $scope.cfg.ruleDescription,
        filter: $scope.filter
      };
      $http.post($scope.apiUrl, payload).then(function () {
        $scope.fetch();
        $scope.clearRule();
      }).catch(function (e) {
        Alerts.raiseAlert({
          "type": "warning",
          "text": "The rule was not able to be created due to a " + e.status + " error.",
          "autoDismiss": true,
          "autoDismissTimeout": 3000
        });
      });
    };
    var validateRule = function validateRule(description, activities, verbs, dateFilter) {
      if (description === '') {
        $scope.formErrors.push('Description can not be blank.');
      }
      if (activities.length === 0 && verbs.length === 0 && !dateFilter) {
        $scope.formErrors.push('At least one activity, verb id, or date filter must be added.');
      }
      return $scope.formErrors.length === 0;
    };
    $scope.clearRule = function () {
      delete $scope.datePickerConfig.dateFilter;
      $scope.cfg.ruleDescription = '';
      $scope.cfg.selectedActivities = [];
      $scope.cfg.selectedVerbs = [];
      $scope.formErrors = [];
      $scope.showRuleForm = false;
      $anchorScroll('app-main');
    };
    var getStatementsPreview = function getStatementsPreview() {
      var _$scope$cfg2 = $scope.cfg,
        selectedActivities = _$scope$cfg2.selectedActivities,
        selectedVerbs = _$scope$cfg2.selectedVerbs;
      var dateFilter = $scope.datePickerConfig.dateFilter;
      var filter = StatementArchivingUtils.buildFilter(selectedActivities, selectedVerbs, dateFilter);
      $scope.loadingStatements = true;
      var searchUrl = Api.url('/interactions/search');
      var formPostHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      var requestData = {
        'cardFilter': JSON.stringify(filter),
        'limit': 5,
        'orderBy': null
      };
      $http.post(searchUrl, $.param(requestData), {
        headers: formPostHeaders
      }).then(function (response) {
        var rawStatements = response.data.results[0].result;
        var _StatementUtils$proce = StatementUtils.processStatements(rawStatements),
          decoratedStatements = _StatementUtils$proce.decoratedStatements,
          original = _StatementUtils$proce.original,
          scrubbed = _StatementUtils$proce.scrubbed;
        $scope.statements = decoratedStatements;
        $scope.original = original;
        $scope.scrubbed = scrubbed;
        $scope.resultsDateType = filter.dateFilter ? filter.dateFilter.fieldName : 'timestamp';
        $scope.statementsCount = response.data.totalHits;
        $scope.loadingStatements = false;
      }).catch(function (e) {
        Alerts.raiseAlert({
          "type": "warning",
          "text": "The statements could not be loaded due to a " + e.status + " error.",
          "autoDismiss": true,
          "autoDismissTimeout": 3000
        });
        $scope.loadingStatements = false;
      });
    };

    // List Items
    $scope.displayFilter = function (filter) {
      try {
        $scope.filter = JSON.stringify(filter, null, 2);
      } catch (e) {
        $scope.filter = filter;
      }
      $scope.showFilterModal = $uibModal.open({
        templateUrl: 'modules/app/data/archiving/filter-modal.html',
        controller: 'FilterModalCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $scope.removeActiveText = function (rule) {
      delete rule.activeText;
    };
    $scope.toggleActiveText = function (rule) {
      rule.activeText = rule.active ? 'Deactivate' : 'Activate';
    };
    $scope.toggleActive = function (rule) {
      rule.active = !rule.active;
      $http.put($scope.apiUrl + '/' + rule.id, rule).then(function () {
        var activeStatus = rule.active ? 'activated' : 'deactivated';
        Alerts.raiseAlert({
          "type": "success",
          "text": "The rule was " + activeStatus,
          "autoDismiss": true,
          "autoDismissTimeout": 2000
        });
        $scope.fetch();
      }).catch(function (e) {
        Alerts.raiseAlert({
          "type": "danger",
          "text": "A " + e.status + " error occurred while trying to update the rule.",
          "autoDismiss": true,
          "autoDismissTimeout": 3000
        });
        $scope.fetch();
      });
    };

    // Watchers
    $scope.$watch('cfg.selectedActivities', function (after, before) {
      if (after.length !== before.length) {
        _.debounce(getStatementsPreview, 1000)();
      }
    }, true);
    $scope.$watch('cfg.selectedVerbs', function (after, before) {
      if (after.length !== before.length) {
        _.debounce(getStatementsPreview, 1000)();
      }
    }, true);
    $scope.$watch('datePickerConfig', _.debounce(getStatementsPreview, 1000), true);
  }]).controller('FilterModalCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }]);
})();
